import React from "react";
import { Card } from "antd";
import "./Card.css";

const CardWizz = (props) => {
  let classes = "default-card";
  if (props.className) {
    classes = classes.concat(" ").concat(props.className);
  }

  return (
    <Card {...props} className={classes}>
      {props.children}
    </Card>
  );
};

export default CardWizz;
